<div [class.disabled-with-backdrop]="disabled" id="create-new-brand" class="card">
  <div class="backdrop"></div>

  <div class="card-header">
    {{ "Create new brand" | translate }}
  </div>

  <div class="card-body">
    <astrobin-brand-editor-form
      [form]="form"
      [model]="model"
      [name]="name"
      (suggestionSelected)="brand.emit($event)"
    ></astrobin-brand-editor-form>
  </div>

  <div class="card-footer">
    <button
      [class.loading]="loadingService.loading$ | async"
      (click)="brand.emit(null)"
      class="btn btn-sm-block btn-secondary"
    >
      {{ "Cancel" | translate }}
    </button>

    <button
      [class.loading]="(loadingService.loading$ | async) || form.pending"
      [disabled]="form.invalid"
      (click)="createBrand()"
      class="btn btn-sm-block btn-primary"
    >
      {{ "Create" | translate }}
    </button>
  </div>
</div>
